import {apiV3, createApiV3} from '@rambler-id/transport'

const encryptedApiV3 = createApiV3({
  encryptionKey: process.env.PUBLIC_KEY,
  encryptionFields: [
    'parameters',
    'password',
    'oldPassword',
    'newPassword',
    'code',
    'login',
    'email',
    'username',
    'account',
    'secret',
    'checkToken',
    'accountId',
    'attestation'
  ]
})

export {apiV3, encryptedApiV3}
